import React from "react";
import Plus from "../../../../assets/svgs/Plus";

const InvoiceFrequency = () => {
  return (
    <div className="overflow-x-hidden sm:w-full text-xs sm:text-lg   ">
      <div className="shadow-xl py-5 overflow-x-auto border-l border-r">
        <div>
          <div className="flex items-start justify-between text-center space-x-5">
            <h2 className="text-xs sm:text-lg   w-4/12">Employees</h2>
            <h2 className="text-xs sm:text-lg   w-4/12">Invoice Frequency</h2>
            <h2 className="text-xs sm:text-lg   w-4/12">Terms & Conditions</h2>
          </div>

          <hr className="w-full my-2 h-0.5 bg-gray-200" />

          <div className="flex justify-between items-start text-center space-x-5">
            <div className="w-4/12">
              <div className="flex flex-wrap items-start justify-center space-x-2">
                <div className="flex flex-col justify-center space-y-1">
                  <div className="w-6 h-6 bg-gray-400 rounded-full shadow"></div>
                  <p className="text-xs">Grev</p>
                </div>
                <div className="flex flex-col justify-center space-y-1">
                  <div className="w-6 h-6 bg-gray-400 rounded-full shadow"></div>
                  <p className="text-xs">Grev</p>
                </div>
                <div className="flex flex-col justify-center space-y-1">
                  <div className="w-6 h-6 bg-gray-400 rounded-full shadow"></div>
                  <p className="text-xs">Grev</p>
                </div>
                <div className="flex flex-col justify-center space-y-1">
                  <div className="w-6 h-6 bg-gray-400 rounded-full shadow"></div>
                  <p className="text-xs">Grev</p>
                </div>
                <div className="flex flex-col justify-center space-y-1">
                  <div className="w-6 h-6 bg-gray-400 rounded-full shadow"></div>
                  <p className="text-xs">Grev</p>
                </div>
                <div className="flex flex-col justify-center space-y-1">
                  <div className="w-6 h-6 bg-gray-400 rounded-full shadow"></div>
                  <p className="text-xs">Grev</p>
                </div>
                <button className="w-6 h-6 text-white shadow rounded-full bg-pink-700 flex items-center justify-center">
                  <Plus />
                </button>
              </div>
              <p>Total Employees 69</p>
            </div>
            <h2 className="w-4/12  text-xs sm:text-lg  ">3 per Month</h2>
            <div className="w-4/12 justify-center flex items-center space-x-1">
              <span>See</span>
              <button className="w-5 h-5 text-white shadow rounded-full bg-pink-700 flex items-center justify-center">
                <Plus />
              </button>
            </div>
          </div>
        </div>
        <br className="block my-5" />
        <div>
          <div className="flex justify-between text-center space-x-5">
            <h2 className=" text-xs sm:text-lg   w-4/12">Agile Fee</h2>
            <h2 className=" text-xs sm:text-lg   w-4/12">Contracts Ending</h2>
            <h2 className=" text-xs sm:text-lg   w-4/12">Services Provided</h2>
          </div>
          <hr className="w-full my-2 h-0.5 bg-gray-200" />
          <div className="flex justify-between text-center space-x-5">
            <h2 className=" text-xs sm:text-lg   w-4/12">2000€/Month</h2>
            <h2 className=" text-xs sm:text-lg   w-4/12">1</h2>
            <h2 className=" text-xs sm:text-lg   w-4/12">
              Example 1/Example 2
            </h2>
          </div>
        </div>
        <br className="block my-5" />
        <div>
          <div className="flex justify-between text-center space-x-5">
            <h2 className=" text-xs sm:text-lg   w-4/12">Speed YTD</h2>
            <h2 className=" text-xs sm:text-lg   w-4/12">
              Contracts Expiring Soon
            </h2>
            <h2 className=" text-xs sm:text-lg   w-4/12"></h2>
          </div>
          <hr className="w-full my-2 h-0.5 bg-gray-200" />
          <div className="flex justify-between text-center space-x-5">
            <h2 className=" text-xs sm:text-lg   w-4/12">2000€/Month</h2>
            <h2 className=" text-xs sm:text-lg   w-4/12">3</h2>
            <h2 className=" text-xs sm:text-lg   w-4/12"></h2>
          </div>
        </div>
      </div>

      <br />
      <div className="flex justify-start sm:justify-between flex-wrap">
        <div className="mx-3 my-1.5">
          <button className="pl-1 pr-3 py-1 text-xs sm:text-base rounded bg-pink-500 text-white">
            Total Payroll
          </button>
          <p className="text-xs sm:text-base ">Total Spent: 324,135,3€</p>
        </div>
        <div className="mx-3 my-1.5">
          <button className="pl-1 pr-3 py-1 text-xs sm:text-base rounded bg-pink-500 text-white">
            Total Employee Cost
          </button>
          <p className="text-xs sm:text-base ">Total Spent: 324,135,3€</p>
        </div>
        <div className="mx-3 my-1.5">
          <button className="pl-1 pr-3 py-1 text-xs sm:text-base rounded bg-pink-500 text-white">
            Agile Gross payroll
          </button>
          <p className="text-xs sm:text-base ">Total Spent: 324,135,3€</p>
        </div>
      </div>
    </div>
  );
};

export default InvoiceFrequency;
